<template>
  <common-page-table
    :apiName="apiName"
    :nameRole="nameRoleEntity"
    :titleTable="$t('Документы')"
    :paramsGetData="paramsGetData"
    :fieldLand="fieldLang"
    :hasLang="false"
    :prefixEdit="
      `/contract/${$route.params.ContractId}/person/${$route.params.PersonId}/document`
    "
    :prefixShow="
      `/contract/${$route.params.ContractId}/person/${$route.params.PersonId}/document`
    "
    :linkCreate="
      `/contract/${$route.params.ContractId}/person/${$route.params.PersonId}/document/create`
    "
    :keyTable="'id'"
    :alternativeConverter="alternativeConverter"
    :isDefaultConverter="false"
    :deleteParams="deleteParams"
    :apiDeleteName="apiDeleteName"
  />
</template>
<script>
import { NAME_OBJECT } from "../../../../../RoleConstanans";
import CommonPageTable from "../../../commonElement/CommonPageTable.vue";
import { API_METHODS } from "../../../../../constant";
import formatData from "../../../../../helpers/converters/formatData";
import convertLangDataToTable from "../../../../../helpers/converters/convertLangDataToTable";
export default {
  name: "TablePageAttrEntity",
  components: { CommonPageTable },
  data() {
    return {
      fieldLang: "",
      apiName: API_METHODS.GET_ALL_DOCUMENT,
      apiDeleteName: API_METHODS.DELETE_DOCUMENT
    };
  },
  computed: {
    paramsGetData() {
      return { PersonId: this.$route.params.PersonId };
    },
    nameRoleEntity() {
      return NAME_OBJECT.clientPersonDocument;
    }
  },
  methods: {
    deleteParams(id) {
      return { PersonId: this.$route.params.PersonId, DocumentId: id };
    },
    alternativeConverter(dataNow, langNow) {
      if (dataNow && dataNow.length > 0) {
        let tempdataNow = convertLangDataToTable(dataNow, langNow, "", false);
        tempdataNow = tempdataNow.map(item => {
          return {
            ...item,
            validFrom: formatData(item.validFrom),
            validTo: formatData(item.validTo)
          };
        });
        return tempdataNow;
      }

      return [];
    }
  }
};
</script>
